import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Map } from 'immutable';
import style from './style.scss';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  className: PropTypes.string,
  showBackground: PropTypes.bool,
  isSlider: PropTypes.bool,
  useOriginal: PropTypes.bool,
};

function Logo({ event, settings, className = '', showBackground, useOriginal = true, isSlider }) {
  if (settings.get('calendarType') === 'google') return <span />;
  const imagePath = useOriginal ? ['logo', 'original', 'url'] : ['logo', 'url'];
  const logo = event.getIn(imagePath);
  const title = event.get('title');

  return (
    <div className={cn('logo', isSlider ? style.sliderPhoto : style.photo, className)}>
      <img
        src={logo || 'static/default_logo.png'}
        alt={title}
        title={title}
        className={style.mainLogo}
      />
      {showBackground && (
        <img
          src={logo || '/static/default_logo.png'}
          alt={title}
          title={title}
          className={style.backgroundLogo}
        />
      )}
    </div>
  );
}

Logo.propTypes = propTypes;

export default Logo;



// WEBPACK FOOTER //
// ./src/widget/event_components/logo.js